/**
 * Created by Vit on 12.12.2017.
 */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Bem from 'bemHelper';

import 'styles/base/components/hint/_hint.scss';

const classes = new Bem('hint');

/**
 *
 * = Hint Component =
 *
 * === Example ===
 * <Hint text="content" />
 *
 */

class Hint extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    text: PropTypes.string
  };

  render() {
    const { className, text } = this.props;
    if (!text) return null;

    return (
      <div {...classes({ extra: className })}>
        <span {...classes('text')} children={text} />
      </div>
    );
  }
}

export default Hint;
